export default __webpack_public_path__ + "static/media/2.e45d9f0b.png";